export const saoDay = (date) =>
  new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Sao_Paulo",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date(date));
export function filterHistory(
  rows,
  { from, to, source = "all", timeframe = "all" },
) {
  return rows.filter((s) => {
    const date = saoDay(s.resultado_at || s.created_at);
    return (
      date >= from &&
      date <= to &&
      (timeframe === "all" || s.timeframe === timeframe) &&
      (source === "all" ||
        (s.source === "autopilot" ? "autopilot" : "gerador") === source)
    );
  });
}
export function aggregate(rows) {
  const win = rows.filter((x) => x.resultado === "WIN").length,
    loss = rows.filter((x) => x.resultado === "LOSS").length,
    doji = rows.filter((x) => x.resultado === "DOJI").length;
  const confirmations = rows.filter((x) => x.confirmacao != null),
    pending = rows.length - win - loss - doji;
  const group = (key) =>
    Object.values(
      rows.reduce((all, s) => {
        const name = key(s);
        const g = (all[name] ??= {
          name,
          total: 0,
          win: 0,
          loss: 0,
          doji: 0,
          pending: 0,
        });
        g.total++;
        if (s.resultado === "WIN") g.win++;
        else if (s.resultado === "LOSS") g.loss++;
        else if (s.resultado === "DOJI") g.doji++;
        else g.pending++;
        return all;
      }, {}),
    ).map((g) => ({
      ...g,
      rate: g.win + g.loss ? (100 * g.win) / (g.win + g.loss) : 0,
    }));
  const assets = group((s) => s.ativo_display || s.ativo)
    .filter((g) => g.win + g.loss >= 2)
    .sort((a, b) => b.rate - a.rate || a.name.localeCompare(b.name));
  const qualified = assets.filter((g) => g.win + g.loss >= 3);
  const sorted = [...rows]
    .sort(
      (a, b) =>
        new Date(b.resultado_at || b.created_at) -
        new Date(a.resultado_at || a.created_at),
    )
    .filter((x) => ["WIN", "LOSS"].includes(x.resultado));
  let sequence = 0;
  for (const s of sorted) {
    if (s.resultado !== sorted[0]?.resultado) break;
    sequence++;
  }
  return {
    total: rows.length,
    win,
    loss,
    doji,
    pending,
    rate: win + loss ? (100 * win) / (win + loss) : 0,
    confirmation: confirmations.length
      ? confirmations.reduce((n, s) => n + s.confirmacao, 0) /
        confirmations.length
      : 0,
    assets,
    best: qualified[0],
    worst: qualified.at(-1),
    sequence,
    sequenceResult: sorted[0]?.resultado,
    byTimeframe: group((s) => s.timeframe).map((g) => ({
      ...g,
      total: g.win + g.loss + g.pending,
    })),
    byDirection: group((s) => s.direcao),
    byMonth: group((s) => saoDay(s.resultado_at || s.created_at).slice(0, 7)),
  };
}
